import React, {Component} from "react"


export default function(WrappedComponent) {
  return class extends Component {
    state = {
      isVisible: !document.hidden,
      status: document.visibilityState
    }

    handleVisibilityChange = () => {
      this.setState({
        isVisible: !document.hidden,
        status: document.visibilityState
      })
    }

    componentDidMount() {
      document.addEventListener("visibilitychange", this.handleVisibilityChange)
    }

    componentWillUnmount() {
      document.removeEventListener("visibilitychange", this.handleVisibilityChange)
    }

    render() {
      const {isVisible, status} = this.state
      return <WrappedComponent {...this.props} isTabVisible={isVisible} tabStatus={status} />
    }
  }
}
